import React from "react";
import TracksContent from "../FunctionComponents/TracksFolder/TracksContent";

function Tracks() {
  return (
    <>
      <TracksContent />
    </>
  );
}

export default Tracks;
